import { Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output, inject, DestroyRef } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subscription } from 'rxjs';
import * as _ from 'lodash-es';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import {
  buildHeaderDataShell,
  normalizeFilterParams,
  gridPayloadFromActiveScreen,
} from '../../../shared/workspace-element-context';
import { ComponentDefaultsLockUnlockService } from './component-defaults-lock-unlock.service';

@Component({
    selector: 'gtw-component-defaults-lock-unlock',
    templateUrl: './component-defaults-lock-unlock.component.html',
    styleUrls: ['./component-defaults-lock-unlock.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ComponentDefaultsLockUnlockComponent implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<string>();

  private readonly subs = new Subscription();
  private isInitialized = false;
  GENERAL_CONFIG: any = {};
  private globalParams: any = {};
  filterParams: any = {};
  private userSettings: any = {};

  minimise = false;
  mode: 'lock' | 'unlock' = 'lock';
  lockUnlockSelected: any[] = [];
  warningMessage: string | null = null;
  warningExists = false;
  isSaveClicked = false;
  logged_in_user = '';
  curentyear = '';
  scenario = '';
  jcd_key: any;

  constructor(
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService,
    private cdr: ChangeDetectorRef,
    private _snackBar: MatSnackBar, private gtwSnackbar: GtwSnackbarService,
    private lockUnlockService: ComponentDefaultsLockUnlockService,
  ) {}

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.subs.add(this.gtwWorkspace.setTabActive.subscribe(() => {
      this.applyWorkspaceContext();
      this.tryInit();
    }));
    this.subs.add(this.gtwGlobal.globalParamsChanged$.subscribe(() => {
      this.applyWorkspaceContext();
      this.tryInit();
    }));
    this.tryInit();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    this.isInitialized = false;
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const header = buildHeaderDataShell(this.gtwGlobal, this.gtwApp);
    this.GENERAL_CONFIG = header.generalConfigData || {};
    this.globalParams = header.globalParams || {};
    this.userSettings = header.userSettingsData || {};
    this.filterParams = normalizeFilterParams(activeScreen);

    const callbackName = activeScreen?.data?.modalName
      || activeScreen?.data?.modal_name
      || activeScreen?.data?.colData?.call_back
      || '';
    this.mode = callbackName.toLowerCase().includes('unlock') ? 'unlock' : 'lock';
  }

  private tryInit(): void {
    if (this.isInitialized) return;
    if (!this.GENERAL_CONFIG?.base_url) return;
    this.isInitialized = true;

    this.logged_in_user = this.userSettings?.user?.sso_id || this.userSettings?.sso_id || '';
    this.curentyear = this.filterParams.tax_year;
    this.scenario = this.filterParams.scenario;
    this.jcd_key = this.globalParams.jcd_key;

    this.processGridData();
  }

  private processGridData(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const gridPayload = gridPayloadFromActiveScreen(activeScreen);

    if (!gridPayload) return;
    const gridArr = _.clone(Array.isArray(gridPayload) ? gridPayload : []);

    if (gridArr.length === 0) return;

    const firstRow = gridArr[0]?.data;
    if (firstRow?.IS_RETURN_FILED != undefined && firstRow?.IS_RETURN_FILED != null && firstRow.IS_RETURN_FILED == 'Y') {
      this.gtwSnackbar.openSnackBar('Tax Return has already been filed for tax year ' + this.curentyear + '.', 'gtw-snackbar--red', true, 4);
      this.cancel();
      return;
    }

    this.lockUnlockSelected = [];
    this.warningExists = false;
    this.warningMessage = null;

    for (const item of gridArr) {
      const row = item?.data;
      if (!row) continue;

      if (row.BASKET_0 == null || row.BASKET_0 == '') {
        this.gtwSnackbar.openSnackBar('Please select defaults which are Locked/Unlocked', 'gtw-snackbar--red', true, 4);
        this.cancel();
        return;
      }

      if (this.mode === 'lock') {
        if (row.STATUS_FLAG === 'Locked') {
          row.LOCK_STATUS = 'Already Locked';
          this.warningExists = true;
        } else {
          row.LOCK_STATUS = '';
        }
        if (row.STATUS_FLAG === 'Unlocked') {
          row.UNLOCK_STATUS = '';
        }
      } else {
        if (row.STATUS_FLAG === 'Unlocked') {
          row.UNLOCK_STATUS = 'Already Unlocked';
          this.warningExists = true;
        } else {
          row.UNLOCK_STATUS = '';
        }
        if (row.STATUS_FLAG === 'Locked') {
          row.LOCK_STATUS = '';
        }
      }

      this.lockUnlockSelected.push(row);
    }

    if (this.warningExists) {
      this.warningMessage = 'Please resolve the warnings before Save';
    }

    this.sortRows();
    this.cdr.detectChanges();
  }

  private sortRows(): void {
    if (this.mode === 'lock') {
      this.lockUnlockSelected = _.orderBy(this.lockUnlockSelected, ['LOCK_STATUS'], ['desc']);
    } else {
      this.lockUnlockSelected = _.orderBy(this.lockUnlockSelected, ['UNLOCK_STATUS'], ['desc']);
    }
  }

  removeLockUnLockRow(row: any): void {
    const index = this.lockUnlockSelected.indexOf(row);
    if (index > -1) {
      this.lockUnlockSelected.splice(index, 1);
    }

    this.warningExists = false;
    this.warningMessage = null;

    for (const item of this.lockUnlockSelected) {
      if (this.mode === 'lock' && item.STATUS_FLAG === 'Locked') {
        this.warningExists = true;
      }
      if (this.mode === 'unlock' && item.STATUS_FLAG === 'Unlocked') {
        this.warningExists = true;
      }
    }
    if (this.warningExists) {
      this.warningMessage = 'Please resolve the warnings before Save';
    }
    this.cdr.detectChanges();
  }

  save(): void {
    this.isSaveClicked = true;

    if (this.lockUnlockSelected.length === 0) {
      this.isSaveClicked = false;
      this.gtwSnackbar.openSnackBar('Please select atleast one row for ' + (this.mode === 'lock' ? 'Locking' : 'Unlocking'), 'gtw-snackbar--red', true, 4);
      return;
    }

    const alreadyStatus = this.mode === 'lock' ? 'Locked' : 'Unlocked';
    const lockFlag = this.mode === 'lock' ? 'L' : 'U';

    let allCCKeys = '';
    for (const item of this.lockUnlockSelected) {
      if (item.STATUS_FLAG != alreadyStatus) {
        allCCKeys = allCCKeys === '' ? '' + item.COMBINATION_KEY : allCCKeys + ',' + item.COMBINATION_KEY;
      }
    }

    const message = this.mode === 'lock'
      ? 'Selected Entity has been locked.'
      : 'Selected CC has been unlocked.';

    this.lockUnlockService.saveLockAndUnLocking(
      this.GENERAL_CONFIG.base_url,
      this.globalParams,
      this.filterParams,
      allCCKeys,
      lockFlag
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (result: any) => {
        const response = result?.data || result || {};
        if (response.errorMessage && response.errorMessage !== 'null') {
          this.isSaveClicked = false;
          this.gtwSnackbar.openSnackBar(response.errorMessage, 'gtw-snackbar--red', true, 4);
        } else {
          this.gtwSnackbar.openSnackBar(message, 'gtw-snackbar--green', true, 4);
          this.requestGridUpdate.emit('refresh');
        }
        this.cdr.detectChanges();
      },
      () => {
        this.isSaveClicked = false;
        this.gtwSnackbar.openSnackBar('Error occurred while saving. Please try again.', 'gtw-snackbar--red', true, 4);
        this.cdr.detectChanges();
      }
    );
  }

  cancel(): void {
    this.requestGridUpdate.emit('cancel');
  }
}
